import { inboxApiHttp } from '@/services/api/tattle-http'
import type {
  SmsClearResponse,
  SmsComposeBody,
  SmsComposeResponse,
  SmsDetailResponse,
  SmsListParams,
  SmsListResponse,
  SmsWaitForBody,
  SmsWaitForResponse
} from './sms-testing.types'

const buildQuery = (params: SmsListParams = {}): string => {
  const usp = new URLSearchParams()
  if (params.to) usp.set('to', params.to)
  if (params.from) usp.set('from', params.from)
  if (params.since) usp.set('since', params.since)
  if (params.body) usp.set('body', params.body)
  if (params.merchantId !== undefined) usp.set('merchantId', String(params.merchantId))
  if (params.q) usp.set('q', params.q)
  if (params.cursor) usp.set('cursor', params.cursor)
  if (params.limit !== undefined) usp.set('limit', String(params.limit))
  const qs = usp.toString()
  return qs ? `?${qs}` : ''
}

export const smsTestingAPI = {
  list: (params: SmsListParams = {}) =>
    inboxApiHttp.get<SmsListResponse>(`/sms${buildQuery(params)}`),

  get: (id: string) => inboxApiHttp.get<SmsDetailResponse>(`/sms/${id}`),

  clear: (to: string) =>
    inboxApiHttp.delete<SmsClearResponse>(`/sms?to=${encodeURIComponent(to)}`),

  /**
   * Synthetic-inject. Returns Twilio-shaped response so the calling SDK
   * (Twilio C#/JS in tattle.net) is happy when its BaseUrl is pointed
   * at the sink in dev/staging.
   */
  compose: (body: SmsComposeBody) =>
    inboxApiHttp.post<SmsComposeResponse>('/sms', body),

  /** Long-poll for the next SMS to a number, returning as soon as one matches or the timeout ends. */
  waitFor: (body: SmsWaitForBody) =>
    inboxApiHttp.post<SmsWaitForResponse>('/sms/wait-for', body)
}
